import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

/**
 * The glass panel of the Repackz storefront (Figma 19074:253858): radius 32,
 * 20 of padding, dark wash under a light one, a hairline rim, heavy blur.
 * Paints from the `--glass-panel-*` tokens of the glass template.
 */
export function GlassCard({ children, className = '' }: Props) {
  return (
    <div
      className={
        'relative rounded-[32px] border-[0.5px] border-solid p-5 text-white ' +
        '[border-color:var(--glass-panel-rim)] [background:var(--glass-panel-fill)] ' +
        '[box-shadow:var(--glass-panel-shadow)] [backdrop-filter:blur(var(--glass-panel-blur))] ' +
        className
      }
    >
      {children}
    </div>
  );
}
